import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: min(4.69vw, 67px) min(13.93vw, 199px) min(1.89vw, 27px);
  align-items: center;
  background-color: #ffffff;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  flex-direction: column;
  h1 {
    font-size: min(4.2vw, 60px);
    line-height: min(3.5vw, 50px);
    color: #000;
    letter-spacing: -0.66px;
    font-family: "robotoblack";
    margin-bottom: min(1.26vw, 18px);
    text-align: center;
  }
  h2 {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(1.26vw, 18px);
    color: #095587;
    text-align: center;
  }
  img {
    width: min(43.54vw, 622px);
    max-width: 100%;
  }
  @media (max-width: 767px) {
    padding: min(5.11vw, 73px);

    h1 {
      /* font-size: 4.7vw;*/
      line-height: 4vw;
      margin-bottom: 2.42vw;
    }
    h2 {
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
    }
    img {
      width: 56vw;
    }
  }
`;

export { Container, Wrapper };